module.exports = "/static/media/icon2.fd5e5ca4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/icon2.svg
// module id = 1486
// module chunks = 0